module.exports = __webpack_public_path__ + "assets/img/KeyReport_002.0145ae7c-ps.jpg";